import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { mapModes } from 'client/utils/constants/appStates';
import ProgressBar from 'client/components/ui/ProgressBar/ProgressBar';

import styles from './MapLoading.module.scss';

const { LOADING } = mapModes;

const MapLoading = ({ mapMode }) => {
    return (
        <div data-testid="mapLoading" className={styles.container}>
            <ProgressBar loading={ mapMode.includes(LOADING) }/>
        </div>
    );
};

MapLoading.propTypes = {
    loading: PropTypes.bool,
    mapMode: PropTypes.array
};

MapLoading.defaultProps = {
    loading: true
};

const mapStateToProps = state => {
    const { map } = state;
    return {
        mapMode: map?.mode || []
    };
};

export default connect(mapStateToProps)(MapLoading);
